import { SeoRenderer } from "../../../common/helpers/seo";

import Login from "./loadable";

export default {
    component: Login,

    renderSeo: (store: any, allMessage: any, lang: string) => {
        SeoRenderer({ title: `Musicators - ${allMessage.slogen}`, allMessage, lang });
    },
};
